import { Playground, PropsTable } from '@versionone/doc-components';
import { Paper } from "../../../../../components/src/Paper";
import { SpacedGroup } from "../../../../../components/src/SpacedGroup";
import * as React from 'react';
export default {
  Playground,
  PropsTable,
  Paper,
  SpacedGroup,
  React
};